import { inject } from '@angular/core';
import { CanActivateFn, Router, UrlTree } from '@angular/router';
import { environment } from 'src/environments/environment';

export const DashboardManagementGuard: CanActivateFn = (): boolean | UrlTree => {
  if ((environment as any).dashboardManagementEnabled === true) {
    return true;
  }
  const router = inject(Router);
  return router.parseUrl('/dashboard/welcome');
};
